import { useStyles } from './styles'
import { SteamItemType } from '@/entities/platforms/steam/types/types'
import { Swiper } from 'swiper/react'
import { SwiperSlide } from 'swiper/react'
import { Mousewheel } from 'swiper/modules'
type ExpensiveItemsListProps = {
  itemsList: SteamItemType[] | null
}

export const ExpensiveItemsList = (props: ExpensiveItemsListProps) => {
  const { itemsList } = props
  const { classes } = useStyles()

  if (!itemsList) return null

  return (
    <div className={classes.root}>
      <Swiper
        modules={[Mousewheel]}
        slidesPerView={2.75}
        spaceBetween={8}
        slidesOffsetBefore={16}
        slidesOffsetAfter={16}
        mousewheel={{
          forceToAxis: true,
        }}
      >
        {itemsList.map((item, index) => (
          <SwiperSlide key={index}>
            <div className={classes.itemContainer}>
              <img
                src={item.icon_url}
                alt=""
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
